import React, { Component } from 'react';
import Confirm from 'react-confirm-bootstrap'
import Modal from 'react-responsive-modal'
import Loader from '../Loader'
import AuditTrail from '../AuditTrail'
import * as constants from '../../Constatnts'
import AddEditModifier from './AddEditModifier';
import AddEditModifierGroup from './AddEditModifierGroup'
import Pagination from "react-js-pagination";

class ModifiersList extends Component {
   
    constructor() {
        super()
        this.state = {
            modifier: null,
            showModal: false,
            showModalGroup:false,
            loading: true,
            searchActiveInactiveAllRecords: 'active',
            searchText: '',
            activePage: 1,
            itemsCountPerPage: 20,
            totalItemsCount: 0,
            recordFrom: 0,
            paginationStatus: '',
            searchActiveInactiveAllRecords: 'active',
            modifiers: []
        }
        // this.handleKeyPress = this.handleKeyPress.bind(this)
        this.onPostModifierSave = this.onPostModifierSave.bind(this);
        this.loadModifiers = this.loadModifiers.bind(this);
        this.onClearSearch = this.onClearSearch.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.showPaginationStatus = this.showPaginationStatus.bind(this);
        this.onSearchActiveInactiveAllRecordsClicked = this.onSearchActiveInactiveAllRecordsClicked.bind(this);
    }

    componentDidMount() {
        this.loadModifiers(this.state.recordFrom, this.state.searchActiveInactiveAllRecords,
            this.state.searchText)
    }
    
    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.onSearchClick()
        }
    }

    handlePageChange(pageNumber) {
        let recordFrom = ((pageNumber - 1) * this.state.itemsCountPerPage)
        this.setState({ activePage: pageNumber, recordFrom: recordFrom });
        this.loadModifiers(this.state.recordFrom, this.state.searchActiveInactiveAllRecords
            ,this.state.searchText)
    }

    loadModifiers(from, option, searchText) {
        this.props.getModifiers(this.props.user.user.RegistrationID, from, this.state.itemsCountPerPage, option, searchText)
            .then((searchResult) => {
                this.setState({ modifiers: searchResult.searchResult, totalItemsCount: searchResult.totalItemsCount, loading: false });
                this.showPaginationStatus();
            })
    }

    onSearchClick() {
        this.setState({ searchFrom: 0 })
        this.loadModifiers(0,
            this.state.searchActiveInactiveAllRecords,
            this.state.searchText)
    }

    onClearSearch() {
        this.setState({
            recordFrom: 0, searchText: '',
            searchActiveInactiveAllRecords: "active"
        })
        this.loadModifiers(0, "active", "", "")
    }

    onSearchActiveInactiveAllRecordsClicked(opiton) {
        this.setState({ searchActiveInactiveAllRecords: opiton, recordFrom: 0 })
        this.loadModifiers(
            0,
            opiton,
            this.state.searchText
        )
    }

    showPaginationStatus() {
        let paginationStatus
        if ((this.state.recordFrom + 1) === this.state.totalItemsCount) {
            paginationStatus = "Showing " + this.state.totalItemsCount + " of " + this.state.totalItemsCount
        }
        else if ((this.state.recordFrom + this.state.itemsCountPerPage + 1) > this.state.totalItemsCount) {
            paginationStatus = "Showing " + (this.state.recordFrom + 1) + " to  " + this.state.totalItemsCount + " of " + this.state.totalItemsCount
        }
        else {
            paginationStatus = "Showing " + (this.state.recordFrom + 1) + " to  " + (this.state.recordFrom + this.state.itemsCountPerPage) + " of " + this.state.totalItemsCount
        }
        this.setState({ paginationStatus: paginationStatus })
    }

    onPostModifierSave() {
        this.setState({showModal:false, modifier: null});
        this.loadModifiers(0, "active", "", "")
    }

    onDeleteModifier(key) {
        this.props.deleteModifiers(key).then(() => {
            this.props.getToastr("Modifier deleted successfully")
            setTimeout(function () {
                this.loadModifiers(
                    0, "active", "", ""
                );
            }.bind(this), 1000)
        })
    }

    render() {
        const btnColStyle = { width: "95px" }
        const revisionHistory = { width: "200px" }
        return <div className="content-wrapper" >
            <section className="content" >
                <div className="row">
                    <div className="col-md-12">
                        <div className="box ">
                            <div className="box-header with-border">
                                <div className="col-md-6">
                                    <font style={{ fontSize: "30px" }}>Modifiers</font>
                                </div>
                                <div className="col-md-6">
                                    <div className="pull-right" style={{ marginTop: "6px" }}>
                                    <button type="button" className="btn btn-default btn-md btn-flat"
                                            onClick={() => this.setState({
                                                showModalGroup: true
                                            })}>Add Modifier Group</button>&nbsp;&nbsp;
                                        <button type="button" className="btn btn-success btn-md btn-flat"
                                            onClick={() => this.setState({
                                                showModal: true, modifier:null
                                            })}>Add Modifier</button>
                                    </div>
                                </div>
                            </div>
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                        <div className="btn-group">
                                            <button type="button" className={this.state.searchActiveInactiveAllRecords === "active" ? "btn btn-primary btn-flat btn-md " : "btn btn-default btn-flat btn-md"}
                                                onClick={() => this.onSearchActiveInactiveAllRecordsClicked("active")}>Active</button>
                                            <button type="button" className={this.state.searchActiveInactiveAllRecords === "inactive" ? "btn btn-primary btn-flat btn-md " : "btn btn-default btn-flat btn-md"}
                                                onClick={() => this.onSearchActiveInactiveAllRecordsClicked("inactive")}>In Active</button>
                                            <button type="button" className={this.state.searchActiveInactiveAllRecords === "all" ? "btn btn-primary btn-flat btn-md " : "btn btn-default btn-flat btn-md"}
                                                onClick={() => this.onSearchActiveInactiveAllRecordsClicked("all")}>All</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label>Search by Modifier Name</label>
                                            <input type="text" className="form-control input-md"
                                                onKeyPress = {this.handleKeyPress}
                                                value={this.state.searchText}
                                                onChange={(evt) => this.setState({ searchText: evt.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <button type="button" className="btn btn-primary btn-flat btn-md pull-right"
                                            style={{ marginTop: "25px", marginLeft: "5px" }}
                                            onClick={this.onSearchClick}
                                        >Search</button>
                                        <button type="button" className="btn btn-default btn-flat btn-md pull-right" style={{ marginTop: "25px" }}
                                            onClick={this.onClearSearch} >Clear</button>
                                    </div>
                                </div>
                                {this.state.loading && <Loader show={this.state.loading} />}
                                {!this.state.loading &&
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Group</th>
                                            <th>Modifier</th>
                                            <th>Price</th>
                                            <th style={revisionHistory}>Revision History</th>
                                            <th style={btnColStyle}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.modifiers.map((modifier) =>
                                            <tr>
                                                <td>{modifier.ModifierGroup}</td>
                                                <td>{modifier.ModifierName}</td>
                                                <td>{modifier.ModifierPrice}</td>
                                                <td>
                                                    {modifier.hasOwnProperty('Action') && <React.Fragment>
                                                        <div>Action : {(new Date(modifier.ActionOn)).toString().substring(0,24)}</div>
                                                        <div>Action By : {modifier.ActionBy}</div>
                                                        <div>Action Date :{(new Date(modifier.ActionOn)).toString().substring(0, 24)}</div>
                                                        <AuditTrail {...this.props} module={constants.MODULE_PRODUCT_MODIFIER} parentKey={modifier.key} />
                                                    </React.Fragment>}
                                                </td>
                                                <td>
                                                    <div className="btn-group">
                                                        {modifier.IsDeleted ? <span className="label label-danger pull-right">Inactive</span> :
                                                        <div>
                                                            <button type="button" className="btn btn-md btn-default btn-flat"
                                                                onClick={() => this.setState({ showModal: true, modifier:modifier })}>
                                                                <i className="fa fa-edit"></i></button>
                                                            <Confirm
                                                                onConfirm={() => this.onDeleteModifier(modifier.key)}
                                                                body="Are you sure you would like to delete this modifier?"
                                                                confirmText="Delete"
                                                                title="Modifier Delete">
                                                                <button className="btn btn-default btn-flat"><i className="fa fa-trash-o"></i></button>
                                                            </Confirm>
                                                        </div>}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                }
                                {this.state.totalItemsCount > 0 && <div className="pull-left" style={{ marginTop: "25px" }}>
                                    {this.state.paginationStatus}
                                </div>}
                                <div className="pull-right">
                                    <Pagination
                                        activePage={this.state.activePage} //this.state.activePage
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.totalItemsCount}
                                        pageRangeDisplayed={2}
                                        onChange={this.handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })} center>
                    <div style={{ width: "700px" }}>
                        <AddEditModifier {...this.props}
                            modifier={this.state.modifier}
                            onClose={() => this.setState({ showModal: false })}
                            onSave={() => this.onPostModifierSave()}
                        />
                    </div>
                </Modal>
                <Modal open={this.state.showModalGroup}
                    onClose={() => this.setState({ showModalGroup: false })} center>
                    <div style={{ width: "500px" }}>
                        <AddEditModifierGroup {...this.props}
                            onClose={() => this.setState({ showModalGroup: false })}/>
                    </div>
                </Modal>
            </section>
        </div>
    }
}

export default ModifiersList